import { render, staticRenderFns } from "./CowsImportPurchaseForm.vue?vue&type=template&id=44ae25c4&scoped=true&"
import script from "./CowsImportPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./CowsImportPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ae25c4",
  null
  
)

export default component.exports